module.exports = __webpack_public_path__ + "img/data.227fcfd9.png";